export default {
  services: {
    auth: {
      name: 'Auth service'
    }
  }
}